import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const fileUploadDriverFactory = (base, body) => {
  return {
    ...baseUniDriverFactory(base, body),
  };
};
